export class Login{
    email:string="";
    password:string=""; 
    confirmPassword:string=""; 
    ResetPasswordCode:string="";
}